import { useMutation, useQuery } from '@tanstack/react-query';
import { subscriptionService, type CreateCheckoutRequest } from '../services/subscription.service';
import { toast } from 'react-hot-toast';

/**
 * Hook for fetching subscription status, limits, and usage
 */
export const useSubscriptionStatus = () => {
  return useQuery({
    queryKey: ['subscriptionStatus'],
    queryFn: () => subscriptionService.getSubscriptionStatus(),
    staleTime: 1000 * 30, // Consider data fresh for 30 seconds (reduced from 5 minutes)
    retry: 1,
  });
};

/**
 * Hook for creating a checkout session and redirecting to Dodo Payments
 */
export const useCreateCheckout = () => {
  return useMutation({
    mutationFn: (request: CreateCheckoutRequest) => 
      subscriptionService.createCheckout(request),
    onSuccess: (data) => {
      // Redirect to Dodo Payments checkout
      window.location.href = data.checkoutUrl;
    },
    onError: (error: any) => {
      console.error('Checkout error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to create checkout session';
      toast.error(errorMessage);
    },
  });
};

/**
 * Hook for getting customer portal URL
 */
export const useCustomerPortal = () => {
  return useMutation({
    mutationFn: () => subscriptionService.getCustomerPortal(),
    onSuccess: (data) => {
      // Redirect to customer portal
      window.location.href = data.portalUrl;
    },
    onError: (error: any) => {
      console.error('Portal error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to access customer portal';
      toast.error(errorMessage);
    },
  });
};
